import React from "react";
import { Dropdown, Nav, Navbar } from "react-bootstrap";
import { Link } from 'react-router-dom';


import { getLink, jsonTree, processImagePath } from "../../util/Functions";
import CatalogContext from "../../contexts/CatalogContext";
import CatalogSearch from "./components/CatalogSearch";

import "./CatalogHeader.scss";
import Catalog from "../../models/Catalog";

export default function CatalogHeader({ navRoutes, uriRoot, className, hasBranding }) {
	const menuItems = navRoutes?.filter(nav => nav.status);

	const [expanded, setExpanded] = React.useState(false);

	const [catalog] = React.useContext(CatalogContext);

	const branding = catalog.options?.branding;
	const routepath = window.location.pathname;

	function reset() {
		setExpanded(false);

		// Compatible with both microsites and private layout gallery
		!Catalog.IsPublic(catalog) &&
			document.querySelector('#_boss._boss').scrollIntoView(true);
	}

	const onNavBarClick = React.useCallback(e => {
		setExpanded(!expanded);
	}, [expanded]);

	const on_logo_click = React.useCallback(() => {
		window.location.href = getLink(catalog.initial_uri);
	}, [catalog]);

	if (!menuItems) {
		return "";
	}

	const logoImg = branding.logo && (<img
		src={processImagePath(branding.logo, "full")}
		className="app-logo"
		alt={branding.name}
		onClick={on_logo_click}
	/>);

	const logo_text = (<h1 className="app-logo" onClick={on_logo_click}>{branding?.name}</h1>)

	const menuTree = jsonTree(menuItems);
	const recursiveMenu = (pages, parent = "0") =>
		pages.filter(page => !page.hidden).map((page, i) => {
			const base = uriRoot.replace(/\/+$/, '');
			let slug = (page.alias_slug || page.slug);
			slug = slug.at(0) === '/' ? slug.slice(1) : slug;
			let relUri = getLink(base + '/' + slug);

			const is_active = routepath === relUri;

			if (page.children.length === 0) {
				return (
					<Dropdown.Item
						key={`${i}/${page.label}`}
						id={`${parent}/${page.label}`}
						active={is_active}
						as={Link}
						to={relUri}
						onClick={reset}
					>
						<label>{page.label}</label>
					</Dropdown.Item>
				);
			}
			const repositionDrop = async target => {
				// Wait 10 ms
				await new Promise(r => setTimeout(r, 10));

				parent = target.parentNode;
				target = parent.querySelector('.dropdown-menu');
				if (!parent.classList.contains('show')) {
					return;
				}

				const targetRight = target?.getBoundingClientRect()?.right;
				const wrapperRight = document.querySelector('#_boss._boss')?.getBoundingClientRect()?.right;
				if (targetRight > wrapperRight) {
					target.style.marginLeft = (wrapperRight - targetRight - 3) + 'px';
				}
			};
			return (
				<Dropdown
					className="dropdown-parent"
					key={i}
					autoClose={true}
					drop={page.level === 0 ? "down" : "end"}
				>
					<Dropdown.Toggle
						className="dropdown-button"
						active={is_active}
						onMouseUp={e => repositionDrop(e.target)}
						onTouchEnd={e => repositionDrop(e.target)}
					>
						<label>{page.label}</label>
					</Dropdown.Toggle>

					<Dropdown.Menu data-count={page.children.length}>
						{recursiveMenu(page.children, `${parent}/${page.label}`)}
					</Dropdown.Menu>
				</Dropdown>
			);
		});

	const headerConfig = catalog.options.appearance.header;
	const classes = ['layout', 'logo-size', 'padding']
		.map(key => headerConfig && headerConfig[key] && `${key}-${headerConfig[key]}`);
	classes.push(className);
	expanded && classes.push('menu-expanded');
	hasBranding && classes.push('has-branded-header');


	return (
		<header className={`${classes.filter(v => v).join(' ')} boss-relative`}>
			<Navbar bsPrefix="_b-navbar" expand="lg" expanded={expanded ? "expanded" : undefined}>

				<div className="navbar-burger boss-absolute">
					<Navbar.Toggle bsPrefix="_b-navbar-toggler"
						aria-controls="basic-navbar-nav"
						onClick={onNavBarClick}
					/>
				</div>

				<Navbar.Brand bsPrefix="_b-navbar-brand logo-wrapper">
					{logoImg ?? logo_text}
				</Navbar.Brand>
				<Navbar.Collapse
					bsPrefix="_b-navbar-collapse"
					id="basic-navbar-nav"
				>
					<div className="nav-wrapper">
						<Nav className="me-auto flex-wrap">
							{recursiveMenu(menuTree)}
						</Nav>
					</div>
					<CatalogSearch size="desktop" />
				</Navbar.Collapse>
				<CatalogSearch size="mobile" />
			</Navbar>
		</header>
	);
}
